import { formatLkr } from '@/lib/format';

interface Item {
  label: string;
  value: number;
  hint?: string;
  primary?: boolean;
}

function valueSize(formatted: string, primary: boolean): string {
  const len = formatted.length;
  if (primary) {
    if (len >= 13) return 'text-lg sm:text-xl';
    if (len >= 11) return 'text-xl sm:text-2xl';
    return 'text-2xl sm:text-3xl';
  }
  if (len >= 13) return 'text-base sm:text-lg';
  if (len >= 11) return 'text-lg sm:text-xl';
  return 'text-xl sm:text-2xl';
}

export function SavingsHero({
  newMonthlyBillLkr,
  yearlyTotalLkr,
  threeYearTotalLkr,
}: {
  newMonthlyBillLkr: number;
  yearlyTotalLkr: number;
  threeYearTotalLkr: number;
}) {
  const items: Item[] = [
    { label: 'Your new monthly bill', value: newMonthlyBillLkr, hint: 'after switching to Atomberg' },
    { label: 'You save in 1 year', value: yearlyTotalLkr, hint: 'electricity + 1 maintenance cycle' },
    {
      label: 'You save in 3 years',
      value: threeYearTotalLkr,
      hint: 'electricity + 4 maintenance cycles',
      primary: true,
    },
  ];

  return (
    <section className="rounded-2xl border-2 border-brand-500 bg-brand-50 p-4 sm:p-6 shadow-sm">
      <div className="flex items-baseline justify-between mb-3 sm:mb-4">
        <h2 className="text-base sm:text-lg font-bold text-slate-900">Switching to Atomberg</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3">
        {items.map((it) => {
          const formatted = formatLkr(it.value);
          const sizeCls = valueSize(formatted, !!it.primary);
          return (
            <div
              key={it.label}
              className={
                it.primary
                  ? 'bg-slate-900 text-white rounded-xl p-4 shadow-md min-w-0'
                  : 'bg-white rounded-xl p-4 border border-brand-200 min-w-0'
              }
            >
              <div className={`text-xs uppercase tracking-wide ${it.primary ? 'text-brand-300' : 'text-slate-500'}`}>
                {it.label}
              </div>
              <div className={`mt-1 font-bold tabular-nums whitespace-nowrap ${sizeCls} ${it.primary ? 'text-brand-400' : 'text-slate-900'}`}>
                {formatted}
              </div>
              {it.hint && (
                <div className={`text-xs mt-1 ${it.primary ? 'text-slate-300' : 'text-slate-500'}`}>
                  {it.hint}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
